<template>
  <div class="columns">
    <div class="column is-7">
      <app-fiche/>
      <app-contact/>
    </div>
    <div class="column is-5">
      <app-carte/>
      <app-historique/>
    </div>
  </div>
</template>

<script>
import fiche from './fiche';
import contact from './contact';
import carte from './carte';
import historique from './historique';


export default {
  name: 'index',
  components: {
    appFiche: fiche,
    appContact: contact,
    appCarte: carte,
    appHistorique: historique,
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/information/index.vue